<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
    productSlug: {
        type: String,
        required: true,
    },
    productName: {
        type: String,
        default: '',
    },
    productImage: {
        type: String,
        default: '',
    },
});

const isSelected = ref(false);
const STORAGE_KEY = 'pricecompare_compare';
const MAX_PRODUCTS = 4;

function getCompareList() {
    if (typeof window === 'undefined') return [];
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch {
        return [];
    }
}

function saveCompareList(list) {
    if (typeof window === 'undefined') return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    // Dispatch custom event so CompareBar reacts
    window.dispatchEvent(new CustomEvent('compare-updated'));
}

function toggle() {
    const list = getCompareList();

    if (isSelected.value) {
        // Remove
        const updated = list.filter(item => item.slug !== props.productSlug);
        saveCompareList(updated);
        isSelected.value = false;
    } else {
        // Add (max 4)
        if (list.length >= MAX_PRODUCTS) {
            return;
        }
        list.push({
            slug: props.productSlug,
            name: props.productName,
            image: props.productImage,
        });
        saveCompareList(list);
        isSelected.value = true;
    }
}

onMounted(() => {
    const list = getCompareList();
    isSelected.value = list.some(item => item.slug === props.productSlug);

    // Listen for external changes
    window.addEventListener('compare-updated', syncState);
});

function syncState() {
    const list = getCompareList();
    isSelected.value = list.some(item => item.slug === props.productSlug);
}
</script>

<template>
    <button
        class="btn btn-sm compare-btn"
        :class="isSelected ? 'btn-primary' : 'btn-outline-secondary'"
        @click.prevent.stop="toggle"
        :title="isSelected ? 'Fjern fra sammenligning' : 'Tilf\u00f8j til sammenligning'"
    >
        <font-awesome-icon :icon="['fas', 'scale-balanced']" class="me-1" />
        <span v-if="isSelected">Valgt</span>
        <span v-else>Sammenlign</span>
    </button>
</template>

<style scoped>
.compare-btn {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
    white-space: nowrap;
}
</style>
